// QueueRoute — /queue guard: own queue subscription OR active employee of a business (see useQueueAccess).
// Thin wrapper over ProtectedRoute with the queue access decision supplied as the feature check.

import type { JSX, ReactNode } from 'react';
import { ProtectedRoute } from './ProtectedRoute.tsx';
import { useQueueAccess } from '../hooks/useQueueAccess.ts';

export const QueueRoute = ({ children }: Readonly<{ readonly children: ReactNode }>): JSX.Element => {
  const access = useQueueAccess();
  return (
    <ProtectedRoute requiredFeature="queue" featureAccess={{ known: access.known, allowed: access.allowed }}>
      {children}
    </ProtectedRoute>
  );
};
